// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i2qO","col":"styles_col__Xl1BB"};